import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { DEFAULT_IMAGE, SITE_NAME, SITE_URL } from "../../seo/routeMeta";

const localeMap = { tr: "tr_TR", en: "en_US", ar: "ar_SA" };

const SEOHead = ({
    title,
    description,
    path = "/",
    image = DEFAULT_IMAGE,
    type = "website",
    robots,
    jsonLd,
}) => {
    const { i18n } = useTranslation();
    const lang = i18n.language?.substring(0, 2) || "tr";
    const canonical = `${SITE_URL}${path}`;
    const locale = localeMap[lang] || "tr_TR";
    // noindex sayfalarda canonical/og:url basmiyoruz: celiskili sinyal olur ve
    // istenen path head'e yansir.
    const indexable = !robots?.includes("noindex");

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {indexable && <link rel="canonical" href={canonical} />}
            <html lang={lang} />
            {robots && <meta name="robots" content={robots} />}

            {/* OpenGraph */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {indexable && <meta property="og:url" content={canonical} />}
            <meta property="og:image" content={image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={SITE_NAME} />
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:locale" content={locale} />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* JSON-LD Structured Data */}
            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
};

export default SEOHead;
